function Spinner() {
  return (
    <div className="mx-auto my-8 w-16 aspect-square rounded-full border-8 border-primary-900 border-r-accent-200 animate-spin"></div>
  );
}

export default Spinner;
